import React from "react";
import store from "src/store";
import EditIcon from "@material-ui/icons/Edit";
import { Memory } from "@material-ui/icons";
import { useStepIndex } from "./step-index-context";

export default function ExpectedResult() {
  var stepIndex=useStepIndex()
    const updateMustFailStatus = async (value) => {
        store.steps[stepIndex]['must_fail'] = value;
        store.updateStore();
    }

    store.useRerenderIfChange(() => [
        store.steps[stepIndex]['must_fail']
    ]);


    var mustFail = store.steps[stepIndex]['must_fail'];

    return (
        <div css="background: white; display:flex;padding-left:10px;padding-top:10px;">
            <div css={`width:110px;flex-shrink:0;`}>
                Must succeed
            </div>
            <div>
                <span css="font-weight: 700">{mustFail ? 'Transaction must revert' : 'Transaction must pass'}
                &nbsp;
                </span>
            {
                !store.isStepReadOnly(stepIndex) &&
                    <span css={`
                        color:#799fd4;
                        cursor: pointer;
                        font-size:13px;
                        font-weight:100;
                        text-decoration-line: underline;
                        justify-self: right;
                    `}
                    onClick={() => {
                            store.removeResults()
                            updateMustFailStatus(!mustFail)
                        }}>Change
              </span>}
            </div>
        </div>
    )
}